<template>
  <b-overlay
    :show="loader.form"
    rounded="sm"
  >
    <b-tabs
      fill
      pills
    >
      <!-- Datos de plan de estudios -->
      <b-tab active>
        <template #title>
          <feather-icon icon="MonitorIcon" />
          <span>Principal</span>
        </template>

        <!-- Datos básicos de un plan de estudios -->
        <validation-observer ref="formPlan">
          <b-card class="blog-edit-wrapper">
            <titleSection
              v-if="!isEmptyObject(planEstudios)"
              :title="(planEstudios.nombre) ? planEstudios.nombre : 'Ingrese nombre del plan de estudios'"
              :subtitle="(planEstudios.activo) ? 'Activo' : 'Inactivo'"
              icon="MonitorIcon"
            />
            <!-- Información de plan de estudios -->
            <b-form
              v-if="!isEmptyObject(planEstudios)"
              class="mt-2"
            >
              <b-row>
                <!-- Especialidad -->
                <b-col md="9">
                  <b-form-group
                    label="Especialidad"
                    label-for="plan-especialidad"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="especialidad"
                      rules="required"
                    >
                      <v-select
                        id="plan-especialidad"
                        v-model="planEstudios.especialidad"
                        placeholder="Sin especialidad"
                        label="nombre_corto"
                        :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="especialidades"
                        :reduce="esp => esp.id"
                        :clearable="false"
                      >
                        <template #no-options>
                          <em style="opacity: 0.5;">No hay resultados para mostar</em>
                        </template>
                      </v-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- aamm -->
                <b-col md="3">
                  <b-form-group
                    label="Año y mes de inicio"
                    label-for="plan-aamm"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="aamm"
                      rules="required"
                    >
                      <b-form-input
                        id="plan-aamm"
                        v-model="planEstudios.aamm"
                        placeholder="aamm"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Nombre -->
                <b-col md="9">
                  <b-form-group
                    label="Plan de estudios"
                    label-for="plan-nombre"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="nombre"
                      rules="required"
                    >
                      <b-form-input
                        id="plan-nombre"
                        v-model="planEstudios.nombre"
                        placeholder="Nombre"
                        :state="errors.length > 0 ? false:null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Estatus -->
                <b-col md="3">
                  <div class="text-nowrap text-center">
                    <b-form-group
                      label="Disponibilidad"
                      label-for="plan-activo"
                      class="mb-2"
                    >
                      <b-form-checkbox
                        v-model="planEstudios.activo"
                        name="check-button"
                        class="mt-25"
                        switch
                        inline
                        :value="1"
                        :unchecked-value="0"
                      >
                        {{ planEstudios.activo ? 'Activo' : 'Inactivo' }}
                      </b-form-checkbox>
                    </b-form-group>
                  </div>
                </b-col>

                <!-- Descripción -->
                <b-col cols="12">
                  <b-form-group
                    label="Descripción"
                    label-for="plan-descripcion"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="descripcion"
                      rules="required"
                    >
                      <b-form-textarea
                        id="plan-descripcion"
                        v-model="planEstudios.descripcion"
                        placeholder="Descripcion del plan de estudios"
                        :state="errors.length > 0 ? false:null"
                        rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Objetivo -->
                <b-col cols="12">
                  <b-form-group
                    label="Objetivo"
                    label-for="plan-objetivo"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="objetivo"
                      rules="required"
                    >
                      <b-form-textarea
                        id="plan-objetivo"
                        v-model="planEstudios.objetivo"
                        placeholder="Objetivo del plan de estudios"
                        :state="errors.length > 0 ? false:null"
                        rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Perfil ingreso -->
                <b-col cols="12">
                  <b-form-group
                    label="Perfil de ingreso"
                    label-for="plan-perfil-ingreso"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="perfil ingreso"
                      rules="required"
                    >
                      <b-form-textarea
                        id="plan-perfil-ingreso"
                        v-model="planEstudios.perfil_ingreso"
                        placeholder="Perfil de ingreso"
                        :state="errors.length > 0 ? false:null"
                        rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <!-- Perfil egreso -->
                <b-col cols="12">
                  <b-form-group
                    label="Perfil de egreso"
                    label-for="plan-perfil-egreso"
                    class="mb-2"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="perfil egreso"
                      rules="required"
                    >
                      <b-form-textarea
                        id="plan-perfil-egreso"
                        v-model="planEstudios.perfil_egreso"
                        placeholder="Perfil de egreso"
                        :state="errors.length > 0 ? false:null"
                        rows="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>

            <!-- Botones de cancelación y guardado -->
            <div class="text-right">
              <!-- Save changes -->
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Guardar cambios
              </b-button>
              <!-- Cancel -->
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                variant="outline-danger"
                @click="(id) ? $emit('update:id', null) : $router.push('/servicio-escolar/dashboard')"
              >
                Cancelar
              </b-button>
            </div>
          </b-card>
        </validation-observer>
      </b-tab>

      <!-- Materias asignadas -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="ClipboardIcon" />
          <span>Materias</span>
        </template>
        <b-card>
          <titleSection
            title="Materias asignadas"
            subtitle="Listado de materias que serán impartidas"
            icon="ClipboardIcon"
            class="mb-2"
          />

          <edit-materia-plan
            :plan-estudios="id"
            :temporalidad-prop="planEstudios.temporalidad"
            @set-loader="loader.form = $event"
            @reload-data="loadPlanData"
          />
        </b-card>
      </b-tab>
    </b-tabs>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BOverlay,
  BFormCheckbox,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BTabs,
  BTab,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import titleSection from '@/views/components/title-section.vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref, onMounted, computed } from '@vue/composition-api'
import store from '@/store'
import vSelect from 'vue-select'
import { isEmptyObject } from '@core/utils/utils'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import editMateriaPlan from './EditMateriasPlan.vue'
import { planInfo, especialidadesList } from '../usePlanes'

export default {
  components: {
    BCard,
    BOverlay,
    BFormCheckbox,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    vSelect,
    BTabs,
    BTab,
    titleSection,
    editMateriaPlan,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const planEstudios = ref({})
    const loader = ref({ form: false })
    const seriacionSelected = ref(null)
    const especialidades = ref([])
    const formPlan = ref(null)

    //* Computed method to get form values
    const getValuesToSend = computed(() => {
      const {
        especialidad, nombre, descripcion, aamm, activo, objetivo, perfil_ingreso, perfil_egreso,
      } = planEstudios.value

      return {
        especialidad, nombre, descripcion, aamm, activo, objetivo, perfil_ingreso, perfil_egreso,
      }
    })

    //* Set plan Estudios data as an empty object
    const newPlanData = () => {
      planEstudios.value = {
        especialidad: null,
        nombre: null,
        descripcion: null,
        aamm: null,
        activo: 0,
        objetivo: null,
        perfil_ingreso: null,
        perfil_egreso: null,
        nombre_especialidad: null,
        nivel: null,
        division: null,
        temporalidad: [],
      }
    }

    //* Save changes
    const saveChanges = () => {
      const toUpdate = getValuesToSend.value
      loader.value.form = true
      const data = {
        task: 'wsplanEstudios',
        action: props.id ? 4 : 3, //* Si hay id es edición [4], sino nuevo item [3]
        datos: JSON.stringify(toUpdate),
      }

      if (props.id !== undefined && props.id) data.plan_estudios = props.id //* Si existe id, envío plan_estudios [Es edición]

      store.dispatch('servicioEscolar/postServicioEscolar', data)
        .then(response => {
          loader.value.form = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Solicitud exitosa',
              text: response.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          },
          { timeout: 8000 })
          if (!props.id) {
            newPlanData()
            emit('refetch-data')
          }
        }, error => {
          loader.value.form = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Actualizar materia]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }

    //* Load plan data
    const loadPlanData = () => {
      loader.value.form = true
      planInfo(props.id).then(response => {
        loader.value.form = false
        planEstudios.value = response
      }, error => {
        loader.value.form = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Información de materia]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    //* Carga catálogo de especialidades
    const loadEspecialidades = () => {
      especialidadesList().then(response => {
        especialidades.value = response
      }, error => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Información de materia]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    onMounted(
      () => {
        if (props.id) loadPlanData() //* If we have an id, so component will edit, get data
        else newPlanData() //* Will create a new item, so put empty data
        loadEspecialidades()
      },
    )

    const validationForm = () => {
      formPlan.value.validate().then(success => {
        if (success) saveChanges()
      })
    }

    return {
      loadPlanData,
      saveChanges,
      loader,
      seriacionSelected,
      planEstudios,
      isEmptyObject,
      especialidades,

      required,
      formPlan,
      validationForm,
    }
  },
}
</script>
